module.exports = __webpack_public_path__ + "media/pages/assets/images/heads-ee0349aa1f49b78e3a02342806d87979.svg";